import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, loading, user, getTenantPath } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 animate-spin text-forest" />
          <p className="text-muted-foreground font-body">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Some pages (e.g. Templates management) are admin-only even for an
  // otherwise-authenticated tenant user — mirrors the backend's own
  // requireTemplateAdmin gating so the URL can't be typed around the
  // hidden nav link.
  if (adminOnly && !(user?.role === 'admin' || user?.is_master_admin)) {
    return <Navigate to={getTenantPath('/dashboard')} replace />;
  }

  return children;
};
